// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".show-url-icon svg[data-v-6e5827f6] {\n  font-size: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
